import {getCompanyBilling} from "../../../services/api";
import {useCallback, useEffect, useState} from "react";
import {useActions} from "../../../store/actions";
import {setSubscriptionAction} from "../../../store/actions/global";
import {useSelector} from "react-redux";
import {subscriptionTypeSelector} from "../../../store/selectors/global";
import {SUBSCRIPTION_TYPES} from "../../../utils/constants";

const useCompanyBilling = () => {
  const [companyBilling, setCompanyBilling] = useState({});
  const subscriptionType = useSelector(subscriptionTypeSelector);
  const updateSubscriptionStatus = useActions(setSubscriptionAction);
  const hasSubscription = subscriptionType === SUBSCRIPTION_TYPES.PAID;

  const updateCompanyBilling = useCallback(() => {
    getCompanyBilling()
      .then(({data}) => {
        setCompanyBilling(data);
        if (hasSubscription !== !!data.id) {
          updateSubscriptionStatus(!!data.id);
        }
      });
  }, [updateSubscriptionStatus, hasSubscription]);

  useEffect(() => updateCompanyBilling(), [updateCompanyBilling]);

  return {companyBilling, updateCompanyBilling};
};

export default useCompanyBilling;